// R462: one short sound when an order's kitchen is done. Browsers allow a page to play sound
// only after the person has interacted with it (autoplay rules), so the audio context is made
// and resumed on the first tap or key press (armSound), and playBeep reports whether it could
// play. When it could not, the caller shows a visible badge instead.

type AudioContextCtor = new () => AudioContext

let ctx: AudioContext | null = null

function audioContextCtor(): AudioContextCtor | null {
  const w = globalThis as unknown as { AudioContext?: AudioContextCtor; webkitAudioContext?: AudioContextCtor }
  return w.AudioContext ?? w.webkitAudioContext ?? null
}

/** Called from a user gesture: creates the audio context if needed and resumes it. */
export function armSound(): void {
  const Ctor = audioContextCtor()
  if (!Ctor) return
  try {
    if (!ctx) ctx = new Ctor()
    if (ctx.state !== 'running') void ctx.resume().catch(() => undefined)
  } catch {
    ctx = null
  }
}

export function soundReady(): boolean {
  return ctx !== null && ctx.state === 'running'
}

/** Plays one short beep. Returns false when the browser has not allowed sound yet. */
export function playBeep(): boolean {
  if (!ctx || ctx.state !== 'running') return false
  try {
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.frequency.value = 880
    gain.gain.value = 0.2
    osc.connect(gain)
    gain.connect(ctx.destination)
    osc.start()
    osc.stop(ctx.currentTime + 0.15)
    return true
  } catch {
    return false
  }
}

export function _resetSoundForTest(): void {
  ctx = null
}
